import { z } from 'zod';

import { zodTimeStamp } from '@/utils/zodUtils';

export const Amount = z.object({
  value: z.number(),
  currency: z.string(),
});

export const ProductPayout = z.object({
  product: z.enum([
    'PARKING',
    'ENFORCEMENT',
    'VALIDATION',
    'MONTHLY_PERMIT',
    'VALET_PAYMENT',
    'VALET_TIP',
  ]),
  amount: Amount,
  tax: Amount,
  payout_count: z.number(),
});

export const PendingPayoutSummary = z.object({
  bank_account_id: z.string(),
  total_amount: Amount,
  total_tax: Amount,
  payouts_by_product: z.record(ProductPayout),
  date: zodTimeStamp,
});

export const NextPayoutInfo = z.object({
  product: z
    .enum([
      'PARKING',
      'ENFORCEMENT',
      'VALIDATION',
      'MONTHLY_PERMIT',
      'VALET_PAYMENT',
      'VALET_TIP',
    ])
    .nullable(),
  schedule_type: z.enum(['daily', 'weekly', 'monthly']),
  next_run_time: zodTimeStamp.nullable(),
  cron_expression: z.string(),
  is_enabled: z.boolean(),
  schedule_name: z.string(),
  time_until_next_seconds: z.number().nullable(),
});

export const PayoutInsights = z.object({
  pending_payouts: z.array(PendingPayoutSummary),
  next_payout_schedules: z.array(NextPayoutInfo),
});

export type AmountType = z.infer<typeof Amount>;
export type ProductPayoutType = z.infer<typeof ProductPayout>;
export type PendingPayoutSummaryType = z.infer<typeof PendingPayoutSummary>;
export type NextPayoutInfoType = z.infer<typeof NextPayoutInfo>;
export type PayoutInsightsType = z.infer<typeof PayoutInsights>;

// Product enum for easy use in components
export const ProductEnum = {
  PARKING: 'PARKING' as const,
  ENFORCEMENT: 'ENFORCEMENT' as const,
  VALIDATION: 'VALIDATION' as const,
  MONTHLY_PERMIT: 'MONTHLY_PERMIT' as const,
  VALET_PAYMENT: 'VALET_PAYMENT' as const,
  VALET_TIP: 'VALET_TIP' as const,
};

export const ScheduleEnum = {
  DAILY: 'daily' as const,
  WEEKLY: 'weekly' as const,
  MONTHLY: 'monthly' as const,
};
